import React from 'react'
import Box from '@retracedgmbh/ui-components-lib/Box'
import Typography from '@retracedgmbh/ui-components-lib/Typography'

const ListItem = ({title, subtitle, result, color}) => {
  return (
    <Box flex justify="between" className="tw:p-4 tw:border-b tw:cursor-pointer tw:hover:bg-primary-light">
      <Box>
        <Typography fontWeight="semibold">{title}</Typography>
        <Typography variant="body2" className="tw:text-gray">
          {subtitle}
        </Typography>
      </Box>
      <Box flex align="center">
        <Typography variant="h6" fontWeight="semibold" color={color}>
          {result}
        </Typography>
      </Box>
    </Box>
  )
}

export default ListItem
